module.exports = __webpack_public_path__ + "img/7.fef81636.jpg";